





























import { Component, Vue } from "@/shared/vuepack";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import moment from "moment/moment";
import { HsabExpenseResponse, TransferSchedule } from "@/shared/types";
import * as transferScheduleUtility from "@/employee/Utilities/TransferScheduleUtility";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: { GenericLoadingSpinner }
})
export default class HsabExpenseCardRowSchedule extends Vue {
  hsabExpenseFormStore = useHsabExpenseFormStore();

  get expense (): HsabExpenseResponse {
    return this.hsabExpenseFormStore.expense;
  }

  get schedule (): TransferSchedule {
    if (this.expense) {
      return this.expense.schedule;
    }
    return null;
  }

  get formattedStartDate () {
    return moment(this.schedule.scheduleStartDate).format("MMM DD, YYYY");
  }

  get formattedEndDate () {
    return moment(this.schedule.scheduleEndDate).format("MMM DD, YYYY");
  }

  get formattedConfirmedOnDate () {
    return moment(this.schedule.userConfirmationDate).format("MMM DD, YYYY");
  }

  get scheduleDescription () {
    return transferScheduleUtility.getScheduleDescription(this.schedule);
  }

  get previewDates () {
    return this.hsabExpenseFormStore.generatedCalendarEntries.calendarDates;
  }

  get first10PreviewDates () {
    return this.previewDates.slice(0, 10);
  }

  get isPreviewLoading () {
    return this.hsabExpenseFormStore.isSchedulePreviewLoading;
  }

  get isPreviewLoaded () {
    return this.hsabExpenseFormStore.isSchedulePreviewLoaded;
  }

  getPreviewDateDisplay (str) {
    return moment(str).format("dddd MMMM Do, YYYY");
  }
}
